import React, { useRef } from "react";
import PlusIcon from "../icons/plusicon";
function UploadForm({ item, handleImage, isboth}) {
	const ref = useRef(null);
	return (
		<div className="input_file">
			<input
				type="file"
				id={item?._id}
				ref={ref}
				style={{ display: "none" }}
				onChange={handleImage}
				accept={isboth ? ".png, .jpg, .jpeg, .mp4" : ".png, .jpg, .jpeg"}   
			/>
			<span className="add_sponsor_img_icon"
				onClick={() => {
					ref.current.click();
				}}
			>
			<PlusIcon />
			</span>
			{/* <img className="add_sponsor_img_icon"
                src={PlusIcon}
                onClick={() => {
					ref.current.click();
				}}
			/> */}
    </div>
  );
}

export default UploadForm;
